import api from "./ApiConfig";
import { Apis } from "../config";
import { NotificationManager } from 'react-notifications';
import unauthService from "./unauth";



const GetAllService= async (query) => {
    try {
     
        const result = await api.get(`${Apis.GetAllServices}`, {
       
            headers: { 'Content-Type': 'application/json' }
        });
        let parsedData=JSON.parse(result.data)
        let response=JSON.parse(parsedData.body)
        console.log(parsedData)
        // 
        if (!response.success) {
            NotificationManager.error(response.data.error);
            return null;
        }
        return response.additionalData   
    } catch (error) {
        if(error.status==401){
            unauthService()
           }
        console.error('Error in getting services:', error);
        NotificationManager.error('An error occurred getting services');
        return null;
    }
};


const AddService = async (data) => {
    try {
        // First, check if a service with the same name already exists
        const existingServices = await GetAllService();
        if (existingServices) {
            const exists = existingServices.some(service => 
                service.serviceName.toLowerCase() === data.serviceName.toLowerCase()
            );

            if (exists) {
                NotificationManager.error(`Service '${data.serviceName}' already exists.`);
                return null; // Prevent adding if it exists
            }
        }

        // If it doesn't exist, proceed with adding the new service
        const result = await api.post(Apis.GetAllServices, data, {
      
            headers: { 'Content-Type': 'application/json' }
        });
        let parsedData=JSON.parse(result.data)
        let response=JSON.parse(parsedData.body)
        console.log(response)
            
        if (!response.success) {
            NotificationManager.error(response.data.error);
            return null;
        }
        NotificationManager.success(response.message);

        return response;
    } catch (error) {
        if(error.status==401){
            unauthService()
           }
           NotificationManager.error('An error occurred while adding services');

        console.error('Error in ADDservices:', error);
        return null;
    }
};

const UpdateService = async (data) => {
    try {
        const result = await api.put(`${Apis.GetAllServices}`, data, {
            headers: { 'Content-Type': 'application/json' }
        });
        let parsedData = JSON.parse(result.data);
        let response = JSON.parse(parsedData.body);
        console.log("UpdateService response", response);

        if (!response.success) {
            NotificationManager.error(response.data.error || 'Error updating service');
            return null;
        }
        NotificationManager.success(response.message || 'Service updated successfully');
        return response;
    } catch (error) {
        if(error.status == 401){
            unauthService();
        }
        NotificationManager.error('An error occurred while updating services');
        console.error('Error in UpdateService:', error);
        return null;
    }
};

const DeleteService = async (id) => {
    try {
        console.log("id" , id)
        const result = await api.delete(`${Apis.GetAllServices}?id=${id}`, {
            headers: { 'Content-Type': 'application/json' }
        });
        let parsedData = JSON.parse(result.data);
        let response = JSON.parse(parsedData.body);
        console.log("DeleteService response", response);

        if (!response.success) {
            NotificationManager.error(response.data.error || 'Error deleting service');
            return null;
        }
        NotificationManager.success(response.message || 'Service deleted successfully');
        return response;
    } catch (error) {
        if(error.status == 401){
            unauthService();
        }
        NotificationManager.error('An error occurred while deleting services');
        console.error('Error in DeleteService:', error);
        return null;
    }
};


const GetAllManualJournal= async (query) => {
    try {
        console.log("raeched")
        const result = await api.get(`${Apis.GetAllManualJournal}`, {
       
            headers: { 'Content-Type': 'application/json' }
        });
        let parsedData=JSON.parse(result.data)
        let response=JSON.parse(parsedData.body)
        console.log(parsedData)
        // 
        if (!response.success) {
            NotificationManager.error(response.data.error);
            return null;
        }
        return response.additionalData   
    } catch (error) {
        if(error.status==401){
            unauthService()
           }
        console.error('Error in Get  journal :', error);
        NotificationManager.error('An error occurred while getting journal .');
        return null;
    }
};


const AddManualJournal = async (data) => {
    try {
        // First, check if a manual journal with the same name already exists
        const existingJournals = await GetAllManualJournal();
        if (existingJournals) {
            const exists = existingJournals.some(journal => 
                journal.journalName.toLowerCase() === data.journalName.toLowerCase()
            );

            if (exists) {
                NotificationManager.error(`Manual Journal '${data.journalName}' already exists.`);
                return null; // Prevent adding if it exists
            }
        }

        // If it doesn't exist, proceed with adding the new manual journal
        console.log("Adding new manual journal", data);
        const result = await api.post(Apis.GetAllManualJournal, data, {
      
            headers: { 'Content-Type': 'application/json' }
        });
        let parsedData=JSON.parse(result.data)
        let response=JSON.parse(parsedData.body)
        console.log("parsedData " , response )
        
        if (!response.success) {
            NotificationManager.error(response.data.error);
            return null;
        }
        NotificationManager.success(response.message);

        return response;
    } catch (error) {
        if(error.status==401){
            unauthService()
           }
           NotificationManager.error('An error occurred while adding journal');

        console.error('Error in ADDjournal:', error);
        return null;
    }
};

const UpdateManualJournal = async (data) => {
    try {
        const result = await api.put(`${Apis.GetAllManualJournal}`, data, {
            headers: { 'Content-Type': 'application/json' }
        });
        let parsedData = JSON.parse(result.data);
        let response = JSON.parse(parsedData.body);
        console.log("UpdateManualJournal response", response);

        if (!response.success) {
            NotificationManager.error(response.data.error || 'Error updating manual journal');
            return null;
        }
        NotificationManager.success(response.message || ' Journal updated successfully');
        return response;
    } catch (error) {
        if(error.status == 401){
            unauthService();
        }
        NotificationManager.error('An error occurred while updating manual journal');
        console.error('Error in Update Journal:', error);
        return null;
    }
};

const DeleteManualJournal = async (id) => {
    try {
        const result = await api.delete(`${Apis.GetAllManualJournal}?id=${id}`, {
            headers: { 'Content-Type': 'application/json' }
        });
        let parsedData = JSON.parse(result.data);
        let response = JSON.parse(parsedData.body);
        console.log("DeleteManualJournal response", response);

        if (!response.success) {
            NotificationManager.error(response.data.error || 'Error deleting manual journal');
            return null;
        }
        NotificationManager.success(response.message || 'Manual Journal deleted successfully');
        return response;
    } catch (error) {
        if(error.status == 401){
            unauthService();
        }
        NotificationManager.error('An error occurred while deleting manual journal');
        console.error('Error in DeleteManualJournal:', error);
        return null;
    }
};








export default {
    AddManualJournal,
    AddService ,
    UpdateManualJournal,
    DeleteManualJournal,
    UpdateService,
    DeleteService,
    GetAllService,
    GetAllManualJournal,
};